// logout.js
import AWS from 'aws-sdk';

import { getSession } from ".";


const async_forgetDevice = user => {
  return new Promise((resolve, reject) => {
    user.forgetDevice({
      onSuccess: function (result) {
        resolve("forgot device");
      },
      onFailure: function (error) {
        resolve("no device to forget");
      }
    })
  })
}

export const logout = async user => {
  await getSession(user);
  // Should test to see if there are any devices to forget...
  try {
    await async_forgetDevice(user);
  } catch (e) {
    console.error(e);
  }
  user.signOut();
  AWS.config.credentials.clearCachedId();
}




// WEBPACK FOOTER //
// ./src/utils/user/logout.js